import { basicTheme, getTypography } from '../theme';
import { chmsColor } from './color';
const chmsFontFace = 'ProximaNova';
const chmsFontFamily = `${chmsFontFace}, sans-serif`;
export const ChMSTheme = { ...basicTheme,
  TYPOGRAPHY: getTypography({
    fontFace: chmsFontFace,
    fontFamily: chmsFontFamily
  }),
  COLORS_BASIC: chmsColor.COLORS_BASIC,
  COLORS: chmsColor.COLORS,
  colors: chmsColor.colors
};